const ContinueStatement = {
  print: () => 'continue;'
};

module.exports = ContinueStatement;
